// app/javascript/controllers/form_focus_controller.js
import {Controller} from "stimulus";

export default class extends Controller {
    connect() {
        requestAnimationFrame(() => {
            const focusElement = this.element.querySelector(".form-focus");
            if (focusElement) {
                console.log("Focusing element:", focusElement);
                focusElement.focus();
            } else {
                console.log("No auto-focus element found");
            }
        });
    }
}
